import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-device-logs-card',
  templateUrl: './device-logs-card.component.html',
  styleUrls: ['./device-logs-card.component.scss']
})
export class DeviceLogsCardComponent implements OnInit {

  @Input() deviceLog;

  constructor() { }

  ngOnInit() {
  }

}
